import { OverallDistributionView } from '@viapeople/components'
import { useAggregationStore } from '../stores/aggregationStore'
import { useRatingScaleMax } from './useRatingScaleMax'

export function OverallDistributionSection() {
	const { summary, distributionBuckets } = useAggregationStore()
	const scaleMax = useRatingScaleMax()
	if (!summary || summary.overallDistribution.length === 0) return null
	const handleViewProfile = (userId: string) => {
		const url = new URL(window.location.href)
		url.searchParams.set('tab', 'data-explorer')
		url.searchParams.set('participantId', userId)
		window.open(url.toString(), '_blank')
	}
	return (
		<OverallDistributionView
			distribution={summary.overallDistribution}
			distributionBuckets={distributionBuckets}
			onViewProfile={handleViewProfile}
			scaleMax={scaleMax}
		/>
	)
}
